import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { ReactComponent as CloseIcon } from "../../Assets/iconsv2/generic/closeBtn.svg";
import { ReactComponent as SendMessageIcon } from "../../Assets/iconsv2/chat/SendButton.svg";
import { useTranslate } from '@tolgee/react';

import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import FileAttachmentItem from "./FileAttachmentItem";

const SendFile = ({
  fileInput,
  setFileInput,
  handleSendFileButton,
  selectedConversation,
  fileInputRef,
  messageInputRef,
  handleInputChange,
  handleSendButton,
  inputValue,
}) => {
  const [src, setSrc] = useState({
    src: null,
    type: null,
  });

  const handleClose = () => {
    fileInputRef.current.value = null;
    setFileInput(null);
  };

  const createPreview = (fileInput) => {
    if (!fileInput) {
      return;
    }
    var preview = URL.createObjectURL(fileInput);

    setSrc({
      src: preview,
      type: fileInput.type,
    });
  };

  const mapSendTo = () => {
    if (!selectedConversation.group) {
      if (selectedConversation.quick_chat) {
        return selectedConversation.quick_chat_name;
      }
      return selectedConversation.other_participants[0].name;
    }
    return selectedConversation.group.name;
  };

  const handleSend = (file, message) => {
    handleSendFileButton(file, message);
    handleClose();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSend(fileInput, inputValue);
    }
  };

  useEffect(() => { }, [fileInput]);
  const { t } = useTranslate();
  return (
    <Container>
      <Top>
        <div></div>
        <Title>
          <h1>{t('chat.send_media')}</h1>
        </Title>

        <CloseBtn onClick={() => handleClose()}>
          <CloseIcon />
        </CloseBtn>
      </Top>

      <FilePreview>
        <FileAttachmentItem file={fileInput} />
      </FilePreview>

      <MediaSendDetails>
        <SendTo>
          <h3>{t('chat.send_to')}</h3>
          <h2>{mapSendTo()}</h2>
        </SendTo>
      </MediaSendDetails>
      <MessageInputWrapper onKeyDown={(e) => handleKeyDown(e)}>
        <MessageInput
          // onKeyDown={(e) => handleEsc(e)}
          ref={messageInputRef}
          autoFocus
          placeholder={t('chat.add_caption')}
          value={inputValue}
          onChange={(e) => handleInputChange(e)}
        />
        <SendMessageButton onClick={() => handleSend(fileInput, inputValue)}>
          <SendMessageIcon />
        </SendMessageButton>
      </MessageInputWrapper>
    </Container>
  );
};

export default SendFile;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  bottom: 0;
  height: 100%;
  background: ${({ theme }) => theme.menu.background};
  width: 100%;
  overflow: hidden;
  z-index: 10;
`;
const Top = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px;
  min-height: 74px;
  height: 74px;
  position: relative;
`;
const MediaSendDetails = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  min-height: 56px;
  height: 56px;
  position: relative;
  border-bottom: 1px solid ${({ theme }) => theme.sidebar.borderColor};
`;

const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  svg {
    height: 28px;
    width: 28px;
    color: ${({ theme }) => theme.menu.selectedOpionBackground};
    stroke: ${({ theme }) => theme.sidebar.borderColor};
  }
`;
const Title = styled.div`
  align-items: center;
  display: flex;
  h1 {
    color: ${({ theme }) => theme.menu.primaryTextColor};
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
    text-align: left;
  }
`;

const SendMessageButton = styled.button`
  width: 42px;
  height: 42px;
  border-radius: 100%;
  display: flex;
  jusitfy-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  background: none;
  svg {
    fill: ${({ theme }) => theme.chat.sendBtn};
    color: ${({ theme }) => theme.chat.sendBtnBorder};
  }
  &:disabled {
    opacity: 0.5;
    cursor: inherit;
  }
`;

const SendTo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  h2 {
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    color: ${({ theme }) => theme.menu.primaryTextColor};
  }
  h3 {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: ${({ theme }) => theme.menu.primaryTextColor};
    opacity: 0.5;
  }
`;

const MessageInput = styled.input`
  width: 100%;
  border-radius: 4px;
  padding: 10px 16px;
  border: none;
  background: ${({ theme }) => theme.chat.messageInputBackground};
  color: ${({ theme }) => theme.chat.messageInputTextColor};
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;

  &:focus {
    outline: none;
  }
`;
const MessageInputWrapper = styled.div`
  display: flex;
  background: ${({ theme }) => theme.chat.messageInputWrapperBackground};
  padding: 16px;
  min-height: 74px;
  height: 74px;
  min-height: 74px;
  max-height: 74px;
  height: 100%;
  gap: 12px;
`;

const FilePreview = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-height: calc(100% - 204px);
  background: ${({ theme }) => theme.menu.groupContentBackground};
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  p {
    color: ${({ theme }) => theme.menu.primaryTextColor};
  }
`;
